<div id="package-details-default-view">
  <div class="tab-nav-container">
    <hyperkit-tab-bar
      variant="primary"
      mode="underline"
      [controlled]="true"
      [overflow]="'compact'"
      [activeTabValue]="subTab()"
      (tabValueChange)="selectTab($event)"
    >
      @for (tab of tabs(); track tab.id) {
        <hyperkit-tab
          [text]="tab.text"
          [value]="tab.id"
          [selected]="subTab() === tab.id"
          (tabClick)="selectTab(tab.id)"
        ></hyperkit-tab>
      }
    </hyperkit-tab-bar>
  </div>

  <div class="tab-panel-content">
    @switch (subTab()) {
      @case ('overview') {
        <default-overview-tab></default-overview-tab>
      }
      @case ('query-logic') {
        <default-query-logic-tab></default-query-logic-tab>
      }
      @case ('research') {
        <default-research-tab></default-research-tab>
      }
      @case ('mitre') {
        <default-mitre-tab></default-mitre-tab>
      }
      @case ('references') {
        <default-references-tab></default-references-tab>
      }
      @case ('response-actions') {
        <default-response-actions-tab></default-response-actions-tab>
      }
    }
  </div>
</div>
